import mixpanel from 'mixpanel-browser'

export const resetIdentityOfDifferentUser = (user) => {
  const identifiedUserId = mixpanel.get_property('$user_id')
  if (identifiedUserId && String(identifiedUserId) !== String(user.id)) {
    mixpanel.reset()
  }
}
